import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useVsiAppContext } from "../stores/VsiApp";
import styles from "../utils/themeStyles";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

function VsiModal ({ size, header, children, footer, isOpen, toggle }) {
	const { theme } = useVsiAppContext();
	
	
	return (
		<Modal className={`bg-${theme} rounded`}  style={{color: styles[theme].textColor }}
					 isOpen={isOpen}
					 toggle={toggle}
					 size={size}>
			{header ? (
				<ModalHeader className={`bg-${theme}`}>
					{header}
				</ModalHeader>
			) : null}
			{children ? (
				<ModalBody className={`bg-${theme}`}>
					{children}
				</ModalBody>
			) : null}
			{footer ? (
				<ModalFooter className={`bg-${theme}`}>
					{footer}
				</ModalFooter>
			) : null}
		</Modal>
	)
}

export default withErrorBoundary(VsiModal, GeneralErrorBoundary);
